<script>
// import VuePhoneNumberInput from "vue-phone-number-input";
// import DatePicker from "vue2-datepicker";
import { required } from "vuelidate/lib/validators";
//import * as cloneDeep from "lodash.clonedeep";
import {
  UPDATE_REMITTANCES_BANK_ACCOUNT,
  FETCH_BANK_LIST
} from "@/state/actions.type";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
export const CHAIPAY_APP_URL = process.env.VUE_APP_CHAIPAY_FRONTEND_URL;
export const CHECKOUT_BASE_URL = process.env.VUE_APP_CHECKOUT_BASE_URL;
export default {
    components: {
        VuePhoneNumberInput,
        // DatePicker
    },
    props: {
        isAddBankAccountModalOpen: Boolean,
        bankdetails: Object
    },
    validations: {
        bankdetails: {
            country: { required },
            bank_id:{},
            currency:{required},
            bank_name:{required},
            // remittance_source:{required},
            // remittance_purpose:{},
            account_number:{required},
            account_type:{required},
            ifsc:{},
            branch:{},
            transit_code:{},
            sort_code:{},
            swift:{},
            bsb_code:{},
            routing_number:{},
            iban:{},
            wing_money_number:{},
            card_number:{},
            first_name:{required},
            last_name:{required},
            phone_number:{required}
        },
    },
    data() {
        return {
            orderLink: "",
            typesubmit: false,
            max: 50,
            add_fields:false,
            add_fields_data: [{"key": "", "value": ""}],
            add_fields_error:false,
            bank_code_number:null,
            timeOptions: [],
            unitOptions: [],
            url_reference: false,
            checkout_base_url: CHECKOUT_BASE_URL,
            //phoneNumber: "",
            phoneNumberVal: null,
            bankList:{},
            uuid :"",
            chaiPayBankDetails: {
                //amount: "",
                
                country: "",
                bank_id:"",
                currency:"",
                bank_name:"",
                // remittance_source:"",
                // remittance_purpose:"",
                account_number:"",
                account_type:"",
                ifsc:"",
                branch:"",
                transit_code:"",
                sort_code:"",
                swift:"",
                bsb_code:"",
                routing_number:"",
                iban:"",
                wing_money_number:"",
                card_number:"",
                first_name:"",
                last_name:"",
                phone_number:"",
                phone_country:""
                // active:true,
                // default:true




            },
        }
    },
    async created() {
        this.loadData();    
    },
    watch: {
        phoneNumberVal: function (val) {
            console.log(val)
            this.bankdetails.phone_number = (val && val.phoneNumber) ? `${val.phoneNumber.replace(/ /g,'')}` : ""
            this.bankdetails.phone_country = (val && val.countryCallingCode) ? `${val.countryCallingCode.replace(/ /g,'')}` : ""
            // this.chaiPayMerchantDetails.billing_details_billing_phone = val
            //   ? val.formattedNumber
            //   : "";
        },
        
        'bankdetails.country'(value) {
            switch (value) {
                case 'VN':
                this.bankdetails.currency = "VND";
                break;
                case 'TH':
                this.bankdetails.currency = "THB";
                break;
                case 'SG':
                this.bankdetails.currency = "SGD";
                break;
                case 'ID':
                this.bankdetails.currency = "IDR";
                break;
                case 'PH':
                this.bankdetails.currency = "PHP";
                break;
                case 'KR':
                this.bankdetails.currency = "KRW";
                break;
                default:
                break;
            }
        },
        
    },
    computed: {
        convertCountryToCurrency() {
            return this.$store.getters["auth/getConvertCountry"];
        },
        // paymentLinkDetailStore() {
        //     return this.$store.state.paymentlinks.pageDetails;
        // }
    },
    methods: {
        closeBankDetailsModal() {
            document.querySelector('.mdi-close').click();
        },
        fetchBankAccounts(){
            return this.$store.state.remittanceBankAccounts.content.content;
        },
        loadData(){
            this.$store.dispatch(`remittanceBankAccounts/${FETCH_BANK_LIST}`)
            .then((response) => {
                console.log("res", response)
                this.bankList = response
                //console.log(this.bankList["content"]["data"]["master_code_list"])

            //this.orderLink = response.payment_link;
            })
            .catch((error) => {
            // error
            console.log("error", error);
            });

        },
        
        submitBankDetail(event) {
            
            this.typesubmit = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            const addBankAccountDetails = {
                
                currency: event.target.currency.value,
                country: event.target.country.value,
                bank_id: parseInt(this.bank_code_number),
                bank_name: event.target.bank_name.value,
                // remittance_source: event.target.remittance_source.value,
                // remittance_purpose: event.target.remittance_purpose.value,
                account_number: event.target.account_number.value,
                account_type: event.target.account_type.value,
                ifsc: event.target.ifsc.value,
                branch: event.target.branch.value,
                transit_code: event.target.transit_code.value,
                sort_code: event.target.sort_code.value,
                swift: event.target.swift.value,
                bsb_code: event.target.bsb_code.value,
                routing_number: event.target.routing_number.value,
                iban: event.target.iban.value,
                wing_money_number: event.target.wing_money_number.value,
                card_number: event.target.card_number.value,
                first_name: event.target.first_name.value,
                last_name: event.target.last_name.value,
                phone_number: this.bankdetails.phone_number,
                phone_country: this.bankdetails.phone_country,
                uuid:this.$v.bankdetails.$model.uuid,
                active: this.$v.bankdetails.$model.active ? true : false,
                default: this.$v.bankdetails.$model.default ? true : false
                
            };
            // Dispatch action to add payment links
            
            
            this.$store.dispatch(`remittanceBankAccounts/${UPDATE_REMITTANCES_BANK_ACCOUNT}`, addBankAccountDetails)
            .then(() => {
            //this.orderLink = response.payment_link;
            this.$notify({
                type: "success",
                text: "Updated bank acounts details successfully.",
                closeOnClick: true,
            });
            setTimeout(() => {
                this.fetchBankAccounts();
            }, 500);
            this.closeBankDetailsModal();
            })
            .catch((error) => {
            // error
            console.log("error", error);
            this.$notify({
                type: "error",
                text: this.$store.state.notification.message,
                closeOnClick: true,
                });
            });
        },
       
        setbank(event){
            this.bankList.content && this.bankList.content.data.master_code_list.map((val)=> {
                if(val.label === event){
                    this.bank_code_number = val.code
                }

            })
            
            //this.bank_code_number = bank;
        },
        validateState(name) {
            const { $dirty, $error } = this.bankdetails[name];
            return $dirty ? !$error : null;
        },
        
    }
};
</script>

<template>
    <div>
        <form
            v-show="!orderLink"
            class="row"
            @submit.prevent="submitBankDetail"
        >

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>
                        <!-- <i class="mdi mdi-account mr-2"></i> -->
                        Active </label
                        >
                        <input
                            v-model.trim="bankdetails.active"
                            type="checkbox"
                            class=" mx-2 mt-4 form-group"
                            name="active"
                        />
                        <!-- <div
                            v-if="$v.bankdetails.active.$error"
                            class="invalid-feedback"
                        > -->
                        <!-- {{
                            "Max 30 characters are allowed"
                        }} -->
                        <!-- </div> -->
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>
                        <!-- <i class="mdi mdi-account mr-2"></i> -->
                        Default </label
                        >
                        <input
                            v-model.trim="bankdetails.default"
                            type="checkbox"
                            class=" mx-2 mt-4 form-group"
                            name="default"
                        />
                        <!-- <div
                            v-if="$v.bankdetails.active.$error"
                            class="invalid-feedback"
                        > -->
                        <!-- {{
                            "Max 30 characters are allowed"
                        }} -->
                        <!-- </div> -->
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="form-group position-relative">
                        <label
                        > Country Code
                        <span class="text text-danger">*</span></label
                        >
                        <img
                            v-if="bankdetails.country == 'VN'"
                            class="flag_images"
                            src="@/assets/images/flags/vietnam1.png"
                            alt=""
                        />
                        <img
                            v-if="bankdetails.country == 'TH'"
                            class="flag_images"
                            src="@/assets/images/flags/thailand.jpeg"
                            alt=""
                        />
                        <img
                            v-if="bankdetails.country == 'SG'"
                            class="flag_images"
                            src="@/assets/images/flags/singapore.png"
                            alt=""
                        />
                        <img
                            v-if="bankdetails.country == 'ID'"
                            class="flag_images"
                            src="@/assets/images/flags/indonesia.png"
                            alt=""
                        />
                        <img
                            v-if="bankdetails.country == 'PH'"
                            class="flag_images"
                            src="@/assets/images/flags/philippines.png"
                            alt=""
                        />
                        <img
                            v-if="bankdetails.country == 'KR'"
                            class="flag_images"
                            src="@/assets/images/flags/korea.jpg"
                            alt=""
                        />
                        <b-form-select
                            name="country"
                            v-model="bankdetails.country"
                            class="form-control custom-select-for-flag"
                        >
                            <b-form-select-option value="ID">{{
                                "ID"
                            }}</b-form-select-option>
                            <b-form-select-option value="PH">{{
                                "PH"
                            }}</b-form-select-option>
                            <b-form-select-option value="SG">{{
                                "SG"
                            }}</b-form-select-option>
                            <b-form-select-option value="TH">{{
                                "TH"
                            }}</b-form-select-option>
                            <b-form-select-option value="VN">{{
                                "VN"
                            }}</b-form-select-option>
                            <b-form-select-option value="KR">{{
                                "KR"
                            }}</b-form-select-option>
                        </b-form-select>
                    <div
                        v-if="$v.bankdetails.country.$error || $v.bankdetails.country.$error"
                        class="invalid-feedback"
                    >
                        {{
                            "This value is required"
                        }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group position-relative">
                    <label
                    >{{ $t("views.payment_links.currency")
                    }}<span class="text text-danger">*</span></label
                    >
                    <img
                        v-if="bankdetails.currency == 'VND'"
                        class="flag_images"
                        src="@/assets/images/flags/vietnam1.png"
                        alt=""
                    />
                    <img
                        v-if="bankdetails.currency == 'THB'"
                        class="flag_images"
                        src="@/assets/images/flags/thailand.jpeg"
                        alt=""
                    />
                    <img
                        v-if="bankdetails.currency == 'SGD'"
                        class="flag_images"
                        src="@/assets/images/flags/singapore.png"
                        alt=""
                    />
                    <img
                        v-if="bankdetails.currency == 'IDR'"
                        class="flag_images"
                        src="@/assets/images/flags/indonesia.png"
                        alt=""
                    />
                    <img
                        v-if="bankdetails.currency == 'PHP'"
                        class="flag_images"
                        src="@/assets/images/flags/philippines.png"
                        alt=""
                    />
                    <img
                        v-if="bankdetails.currency == 'KRW'"
                        class="flag_images"
                        src="@/assets/images/flags/korea.jpg"
                        alt=""
                    />
                    <b-form-select
                        name="currency"
                        v-model="bankdetails.currency"
                        class="form-control custom-select-for-flag"
                    >
                        <b-form-select-option value="IDR">{{
                            "IDR"
                        }}</b-form-select-option>
                        <b-form-select-option value="PHP">{{
                            "PHP"
                        }}</b-form-select-option>
                        <b-form-select-option value="SGD">{{
                            "SGD"
                        }}</b-form-select-option>
                        <b-form-select-option value="THB">{{
                            "THB"
                        }}</b-form-select-option>
                        <b-form-select-option value="VND">{{
                            "VND"
                        }}</b-form-select-option>
                        <b-form-select-option value="KRW">{{
                            "KRW"
                        }}</b-form-select-option>
                    </b-form-select>
                    <div
                        v-if="$v.bankdetails.currency.$error || $v.bankdetails.country.$error"
                        class="invalid-feedback"
                    >
                        {{
                            "This value is required"
                        }}
                    </div>
                </div>
            </div>

            <div class="mb-2 ml-2"><h6 style="font-weight:750; font-size: 16px;">Personal Info </h6></div>

            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    First Name<span class="text text-danger">*</span> </label
                    >
                    <input
                        v-model.trim="bankdetails.first_name"
                        type="text"
                        class="form-control"
                        placeholder="Enter first name"
                        name="first_name"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.first_name.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.first_name.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Last Name <span class="text text-danger">*</span></label
                    >
                    <input
                        v-model.trim="bankdetails.last_name"
                        type="text"
                        class="form-control"
                        placeholder="Enter last name"
                        name="last_name"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.last_name.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.last_name.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group">
                  <label
                    >
                    {{ $t("views.payment_links.customer_phone") }}<span class="text text-danger">*</span></label
                  >
                  <VuePhoneNumberInput
                    v-model="bankdetails.phone_number"
                    id='VuePhoneNumber'
                    required
                    @update="phoneNumberVal = $event"
                    :default-country-code="this.bankdetails.phone_country === '91' ? 'IN' : this.bankdetails.phone_country === '62' ? 'ID' : this.bankdetails.phone_country === '60' ? 'MY' : this.bankdetails.phone_country === '63' ? 'PH' : this.bankdetails.phone_country === '65' ? 'SG' : this.bankdetails.phone_country === '82' ? 'KR' : this.bankdetails.phone_country === '66' ? 'TH' : this.bankdetails.phone_country === '84' ? 'VN' : this.bankdetails.phone_country === '886' ? 'TW' : ''"
                    :only-countries="['IN', 'ID', 'MY', 'PH', 'SG', 'KR', 'TH', 'VN', 'TW']"
                  />
                  <!-- <div
                    v-if="typesubmit && $v.chaiPayMerchantDetails.billing_details_billing_phone.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.chaiPayMerchantDetails.billing_details_billing_phone.required">{{ 'This value is required.' }}</span>
                  </div> -->
                </div>
              </div>

            <div class="mb-2 ml-2"><h6 style="font-weight:750; font-size: 16px;">Bank Info </h6></div>

            
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-tooltip-edit mr-2"></i> -->
                    Bank Name <span class="text text-danger">*</span></label
                    >
                    <div class="input-group">
                        <!-- <input
                            v-model.trim="chaiPayBankDetails.bank_name"
                            type="text"
                            class="form-control"
                            placeholder="Bank Name"
                            name="bank_name"
                            
                            :class="{
                            'is-invalid':
                            typesubmit && $v.chaiPayBankDetails.bank_name.$error,
                        }"
                        /> -->
                        <b-form-select
                        name="bank_name"
                        v-model="bankdetails.bank_name"
                        v-on:change="setbank"
                        class="form-control"
                        :class="{
                                'is-invalid':
                                typesubmit && $v.bankdetails.bank_name.$error,
                            }"
                    >
                        
                    <option :key="index" v-for="(option, index) in this.bankList.content && this.bankList.content.data.master_code_list" :data-key="option.code" :value="option.label" >{{ option.label }}</option>

                    </b-form-select>
                        
                        <div
                        v-if="$v.bankdetails.bank_name.$error"
                        class="invalid-feedback"
                        >
                        {{
                            "This field is required"
                        }}
                        </div>
                    </div>
                    <!-- <div
                            v-if="typesubmit && $v.chaiPayMerchantDetails.billing_details_billing_email.$error"
                            class="invalid-feedback"
                            >
                            <span v-if="!$v.chaiPayMerchantDetails.billing_details_billing_email.email">{{ 'This is not valid email.' }}</span>
                            </div> -->
                </div>
            </div>


            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Account Number<span class="text text-danger">*</span></label
                    >
                    <input
                        v-model.trim="bankdetails.account_number"
                        type="text"
                        class="form-control"
                        placeholder="Enter account number"
                        name="account_number"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.account_number.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.account_number.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Account Type<span class="text text-danger">*</span></label
                    >
                    <b-form-select
                        name="account_type"
                        v-model="bankdetails.account_type"
                        class="form-control"
                        :class="{
                                'is-invalid':
                                typesubmit && $v.bankdetails.account_type.$error,
                            }"
                    >
                        <b-form-select-option value="SAVING">{{
                            "SAVING"
                        }}</b-form-select-option>
                        <b-form-select-option value="CURRENT">{{
                            "CURRENT"
                        }}</b-form-select-option>
                        <b-form-select-option value="CHECKING">{{
                            "CHECKING"
                        }}</b-form-select-option>
                        <b-form-select-option value="INDIVIDUAL">{{
                            "INDIVIDUAL"
                        }}</b-form-select-option>
                        <b-form-select-option value="CORPORATE">{{
                            "CORPORATE"
                        }}</b-form-select-option>
                    </b-form-select>
                    <div
                        v-if="$v.bankdetails.account_type.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    IFSC </label
                    >
                    <input
                        v-model.trim="bankdetails.ifsc"
                        type="text"
                        class="form-control"
                        placeholder="Enter ifsc"
                        name="ifsc"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.ifsc.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.ifsc.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Branch</label
                    >
                    <input
                        v-model.trim="bankdetails.branch"
                        type="text"
                        class="form-control"
                        placeholder="Enter branch"
                        name="branch"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.branch.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.branch.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

        <div class="mb-2 ml-2"><h6 style="font-weight:750; font-size: 16px;">International Transfer Info </h6></div>
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Tansit Code</label
                    >
                    <input
                        v-model.trim="bankdetails.transit_code"
                        type="text"
                        class="form-control"
                        placeholder="Enter transit code"
                        name="transit_code"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.transit_code.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.transit_code.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Sort Code</label
                    >
                    <input
                        v-model.trim="bankdetails.sort_code"
                        type="text"
                        class="form-control"
                        placeholder="Enter sort code"
                        name="sort_code"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.sort_code.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.sort_code.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>


            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Swift Code</label
                    >
                    <input
                        v-model.trim="bankdetails.swift"
                        type="text"
                        class="form-control"
                        placeholder="Enter swift"
                        name="swift"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.swift.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.swift.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Bsb Code</label
                    >
                    <input
                        v-model.trim="bankdetails.bsb_code"
                        type="text"
                        class="form-control"
                        placeholder="Enter bsb code"
                        name="bsb_code"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.bsb_code.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.bsb_code.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>


            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Routing Number</label
                    >
                    <input
                        v-model.trim="bankdetails.routing_number"
                        type="text"
                        class="form-control"
                        placeholder="Enter routing number"
                        name="routing_number"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.routing_number.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.routing_number.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>


            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Iban</label
                    >
                    <input
                        v-model.trim="bankdetails.iban"
                        type="text"
                        class="form-control"
                        placeholder="Enter iban"
                        name="iban"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.iban.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.iban.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Wing Money Number</label
                    >
                    <input
                        v-model.trim="bankdetails.wing_money_number"
                        type="text"
                        class="form-control"
                        placeholder="Enter wing money number"
                        name="wing_money_number"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.wing_money_number.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.wing_money_number.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                    <!-- <i class="mdi mdi-account mr-2"></i> -->
                    Card Number </label
                    >
                    <input
                        v-model.trim="bankdetails.card_number"
                        type="text"
                        class="form-control"
                        placeholder="Enter card number"
                        name="card_number"
                        :class="{
                            'is-invalid':
                            typesubmit && $v.bankdetails.card_number.$error,
                        }"
                    />
                    <div
                        v-if="$v.bankdetails.card_number.$error"
                        class="invalid-feedback"
                    >
                    {{
                        "Max 30 characters are allowed"
                    }}
                    </div>
                </div>
            </div>


            <div
                class="col-lg-12 my-1 text-right bg-white"
                style="position: sticky; bottom: 0px; padding-bottom: 15px"
            >
                <div
                    style="
                    background: #fff;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    bottom: 0px;
                    opacity: 0.5;
                    "
                ></div>
                <div style="width: 90%; margin: 0 auto; position: relative">
                    <button
                        style="width: 100%"
                        type="submit"
                        class="btn btn-primary"
                    >
                    Update
                    </button>
                    <button
                        style="width: 100%; margin-top: 10px"
                        @click="closeBankDetailsModal"
                        id="close-payment-link-form"
                        class="btn btn-light mr-2"
                    >
                    {{ $t("button.close") }}
                    </button>
                </div>
            </div>
        </form>
        
    </div>
</template>

<style>
.xmx-datepicker-popup{
  z-index: 9999;
}
</style>

<style lang="css" scoped>
.checkbox-group-custom{
  position: relative;
}
.checkbox-group-custom input{
  display: none;
}
.checkbox-group-custom  label {
  cursor: pointer;
}
.checkbox-group-custom{
  display: inline-block;
}
.checkbox-group-custom  label {
  cursor: pointer;
}
.checkbox-group-custom  label:before {
  content:'';
  -webkit-appearance: none;
  background-color: #EAEAEA;
  border-radius: 4px;
  padding: 9px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 10px;
  bottom:1px;
}
.checkbox-group-custom  label.filled:before {
  background-color: #252B3A;
}
.checkbox-group-custom label.filled:after {
  content: '';
  display: block;
  position: absolute;
  top: 5px;
  left: 6px;
  width: 5px;
  height: 9px;
  border: 1px solid #fff;
  border-width: 0 1px 1px 0;
  transform: rotate(45deg);
}
.cursor-pointer{
  cursor: pointer;
}
::v-deep .billing_details_billing_email.is-valid {
  border-color: #ced4da;
  background-image: none;
  box-shadow: none;
}
::v-deep #VuePhoneNumber .resize-observer{
  display: none;
}
::v-deep .flag_images{
  position: absolute;
  width: 20px;
  top: 42px;
  left: 10px;
}
::v-deep .custom-select-for-flag{
  padding-left:35px ;
}
::v-deep .input-group-addon{
   padding: 10px 10px;
    font-size: 15px;
    line-height: 1;
    text-align: center;
    background-color: #ecf0f1;
    border: 1px solid #dce4ec;
    border-left-color: transparent;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
::v-deep .xmx-datepicker{
  width: 100%;
}
::v-deep .custom-datepicker .xmx-input{
  height: 35px !important;
  padding-top: 4px;
  min-height: unset;
}
</style>